import { ReactNode } from 'react'
import { twMerge } from 'src/utils/tw-merge.util'
import { useTranslation } from 'react-i18next'

type StatisticsBlocProps = {
  children: ReactNode
  isSmallBloc?: boolean
}

const StatisticsBloc = ({ children, isSmallBloc }: StatisticsBlocProps) => {
  return (
    <dl
      className={twMerge(
        'c-border c-border-grey-200 c-rounded-lg c-px-7 c-py-2 c-font-nexa',
        isSmallBloc &&
          'c-inline-block c-align-top c-w-[calc(50%-1rem)] c-mb-4 c-mr-4 even:c-mr-0 statistics-form-stat-block',
      )}
    >
      {children}
    </dl>
  )
}

type StatisticProps = {
  label: string
  value?: string
  isEmphased?: boolean
  children?: React.ReactNode
}
const Statistic = ({ label, value, isEmphased, children }: StatisticProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={twMerge(
        'c-py-3 c-border-b c-border-b-grey-200 c-border-b-solid',
        !isEmphased && 'last:c-border-none',
      )}
    >
      <div className="c-text-sm c-font-nexa c-flex c-items-center c-justify-between">
        <dt
          dangerouslySetInnerHTML={{ __html: label }}
          className={twMerge('c-font-normal', isEmphased && 'c-text-base c-font-semibold')}
        ></dt>
        <dd className={twMerge('c-m-0', isEmphased && 'c-text-xl c-font-semibold')}>
          {value === 'no_data' ? t('pages.statistics.no-data') : value}
        </dd>
      </div>
      {children}
    </div>
  )
}

const SubStatistic = ({ label, value }: StatisticProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={twMerge(
        'c-text-xs c-font-nexa c-flex c-pt-2 c-items-center c-justify-between c-text-gray-500 c-ml-4',
      )}
    >
      <dt className="c-font-normal">{label}</dt>
      <dd className="c-m-0">{value === 'no_data' ? t('pages.statistics.no-data') : value}</dd>
    </div>
  )
}

export { StatisticsBloc, SubStatistic, Statistic }
